export default {
	user: {},
	progress: [],
	isTest: false,
}